import {Action} from 'redux'
import {GrievanceNatureModel} from '../Model/GrievanceNatureModel'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialGrievanceNatureState: IGrievanceNatureState = {
  data: {
    natures: [],
    meta: [],
  },
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface IGrievanceNatureState {
  data?: {
    natures?: GrievanceNatureModel[]
    meta?: {[key: string]: string | number}[]
  }
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
  toggleLoading?: boolean
}

export const reducer = (
  state: IGrievanceNatureState = initialGrievanceNatureState,
  action: ActionWithPayload<IGrievanceNatureState>
) => {
  switch (action.type) {
    case actionTypes.GET_ALL_GRIEVANCE_NATURE_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ALL_GRIEVANCE_NATURE_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_ALL_GRIEVANCE_NATURE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //GET GrievanceNature DATA
    case actionTypes.GET_GRIEVANCE_NATURE_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_GRIEVANCE_NATURE_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_GRIEVANCE_NATURE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Add GrievanceNature
    case actionTypes.ADD_GRIEVANCE_NATURE_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_GRIEVANCE_NATURE_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_GRIEVANCE_NATURE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_GRIEVANCE_NATURE: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    //Update GrievanceNature
    case actionTypes.UPDATE_GRIEVANCE_NATURE_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_GRIEVANCE_NATURE_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_GRIEVANCE_NATURE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Delete
    case actionTypes.DELETE_GRIEVANCE_NATURE_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_GRIEVANCE_NATURE_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_GRIEVANCE_NATURE_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Enable
    case actionTypes.ENABLE_GRIEVANCE_NATURE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_GRIEVANCE_NATURE_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_GRIEVANCE_NATURE_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    //disable
    case actionTypes.DISABLE_GRIEVANCE_NATURE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_GRIEVANCE_NATURE_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DISABLE_GRIEVANCE_NATURE_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }
    //Enable
    case actionTypes.SINGLE_ENABLE_GRIEVANCE_NATURE_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ENABLE_GRIEVANCE_NATURE_SUCCESS: {
      const payload: any = action.payload
      const changedData: any = payload?.data?.nature
      let newData = state?.data?.natures?.map((data) => {
        if (data?.id === changedData?.[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state.data, meta: state?.data?.meta, natures: newData},
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_ENABLE_GRIEVANCE_NATURE_FINISH: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    //Disable
    case actionTypes.SINGLE_DISABLE_GRIEVANCE_NATURE_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DISABLE_GRIEVANCE_NATURE_SUCCESS: {
      const payload: any = action.payload
      const changedData: any = payload?.data?.nature
      let newData = state?.data?.natures?.map((data) => {
        if (data?.id === changedData?.[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state.data, meta: state?.data?.meta, natures: newData},
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DISABLE_GRIEVANCE_NATURE_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
        toggleLoading: false,
      }
    }

    default:
      return state
  }
}

